import { describeStaffSession } from '@/lib/staffSession';
import { useStaffSession } from '@/lib/useStaffSession';

const StaffSessionBanner = () => {
  const text = describeStaffSession(useStaffSession());
  if (!text) return null;
  return (
    <div
      role="status"
      data-testid="staff-session-banner"
      style={{ background: '#0F0F0F', color: '#fff', padding: '8px 16px', fontSize: 13, position: 'sticky', top: 0, zIndex: 50 }}
    >
      {text}
    </div>
  );
};

export default StaffSessionBanner;
